import React, { useCallback, useRef } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import LuckyDucky from '../luckyDucky/LuckyDucky';
import LuckyDuckyIncisor from './LuckyDuckyIncisor';

// New Incisor client is live everywhere (approved 2026-10-08); classic stays at /casino/lucky-ducky-classic.
export const INCISOR_CLIENT_ENABLED = true;

export default function LuckyDuckyRoute() {
    const { user, loading, refreshUser } = useAuth();
    const timer = useRef(null);
    const onBalance = useCallback(() => {
        clearTimeout(timer.current);
        timer.current = setTimeout(() => refreshUser?.(), 400);
    }, [refreshUser]);

    if (!INCISOR_CLIENT_ENABLED) return <LuckyDucky />;
    if (loading) return <div data-testid="ld-incisor-loading" style={{ position: 'fixed', inset: 0, background: '#061b35' }} />;
    return (
        <div data-testid="ld-incisor-root">
            <LuckyDuckyIncisor playerId={user ? user.id : null} onBalance={onBalance} />
        </div>
    );
}
